import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import uuid from "react-uuid";

import { message } from "antd";

import LdasApi from "../../../../apis/Ldas.api";
import { plutusS3 } from "../../../../utils/plutusS3";
import ContentHeaderComponent from "../../../layout/ContentHeaderComponent";
import LdasProductForm from "../LdasProductForm";

/** 제품 등록 폼 검증 */
const validateLdasProductCreateForm = (values) => {
  const brandName = typeof values.brand === "string" ? values.brand.trim() : "";
  const productName = typeof values.name === "string" ? values.name.trim() : "";
  if (!brandName) {
    return { ok: false, message: "브랜드를 입력해 주세요" };
  }
  if (!productName) {
    return { ok: false, message: "제품명을 입력해 주세요" };
  }
  if (!values.categoryTags || values.categoryTags.length === 0) {
    return { ok: false, message: "카테고리를 선택해 주세요" };
  }
  if (!(values.image instanceof File)) {
    return { ok: false, message: "제품 이미지를 선택해 주세요" };
  }
  return { ok: true, brandName, productName };
};

const LdasProductCreateComponent = () => {
  const history = useHistory();
  const [categories, setCategories] = useState([]);
  const submitLockRef = useRef(false);

  // 카테고리 목록 조회 초기 정보
  const fetchCategories = useCallback(async () => {
    try {
      const res = await LdasApi.readLdasCategoryList();
      // console.log("readLdasCategoryList res", res);
      if (res.code === 200) {
        setCategories(res.result.items);
      }
    } catch (error) {
      console.error("readLdasCategoryList", error);
    }
  }, []);
  useEffect(() => {
    fetchCategories();
  }, []);

  /** 1. 제품 이미지 S3 저장 → 공개 URL */
  const saveLdasProductImage = async (file) => {
    const ext = file.type.split("/").pop() || "jpg";
    const key = `image/admin/ldas/product/${uuid().replace(/-/g, "")}.${ext}`;
    const res = await plutusS3
      .putObject({
        Bucket: process.env.REACT_APP_S3_BUCKETNAME,
        Key: key,
        Body: file,
        ContentType: file.type,
      })
      .promise();
    console.log("saveLdasProductImage res", res);
    if (res.success !== true) {
      throw new Error("S3 업로드 실패");
    }
    // const host = (process.env.REACT_APP_S3_HOST || "").replace(/\/$/, "");
    // return `${host}/${key}`;
    return key;
  };

  const handleSubmit = async (values) => {
    if (submitLockRef.current) return;

    const validation = validateLdasProductCreateForm(values);
    if (!validation.ok) {
      message.error(validation.message);
      return;
    }
    const { brandName, productName } = validation;

    submitLockRef.current = true;
    const hideLoading = message.loading("저장 중...", 0);

    try {
      const imageUrl = await saveLdasProductImage(values.image);
      const dto = {
        brandName,
        productName,
        description: (values.description ?? "").trim(),
        imageUrl,
        categoryIds: [Number(values.categoryTags[0].id)] ?? [],
      };

      const res = await LdasApi.createLdasProduct(dto);
      // console.log("createLdasProduct res", res);

      if (res.code === 200) {
        message.success("제품이 등록되었습니다. 로트 번호를 추가해주세요.");
        setTimeout(() => {
          history.push(`/ldas/detail/${res.result}`);
        }, 300);
        return;
      } else {
        message.error(res?.message ?? "제품 등록에 실패했습니다");
      }
    } catch (error) {
      console.error("LdasProductCreate", error);
      message.error("제품 등록 중 오류가 발생했습니다");
    } finally {
      hideLoading();
      submitLockRef.current = false;
    }
  };

  const handleCancel = () => {
    history.push("/ldas/list");
  };

  return (
    <div className="ldas-page">
      <ContentHeaderComponent
        title="새 제품 추가"
        breadcrumb={[
          { label: "제품 관리", onClick: () => history.push("/ldas/list") },
          { label: "새 제품 추가" },
        ]}
      />

      <div className="ldas-page__content">
        <LdasProductForm
          mode="create"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          categories={categories}
          onCategoriesInvalidated={fetchCategories}
        />
      </div>
    </div>
  );
};

export default LdasProductCreateComponent;
